import Reflux from 'reflux';
import { AppActions, MessageActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

const AppStore = Reflux.createStore({
  listenables: [AppActions, MessageActions],
  data: {
    message: null,
    reportBug: false
  },
  getInitialState() {
    return this.data;
  },
  init() {
    if (localStorage) {
      let data = JSON.parse(localStorage.getItem('app'));
      if (data) {
        this.data = data;
        this.trigger(this.data);
      }
    }
  },
  serialize() {
    localStorage.setItem('app', JSON.stringify(this.data));
  },
  sync() {
    this.serialize();
    this.trigger(this.data);
  },
  onSetTitle(title) {
    this.data.title = title;
    this.sync();
  },
  getTitle() {
    return this.data.title;
  },
  genericError(message) {
    this.data.message = {
      message,
      type: 'error',
      translate: false
    };
    this.trigger(this.data);
  },
  translatableMessage(message, type = 'info') {
    this.data.message = {
      message,
      type,
      translate: true
    };
    this.trigger(this.data);
  },
  notify(message) {
    this.message(message, 'notification');
  },
  error(message) {
    this.message(message, 'error');
  },
  info(message) {
    this.message(message, 'info');
  },
  message(message, type = 'info') {
    this.data.message = {
      message,
      type,
      translate: false
    };
    this.trigger(this.data);
  },
  clearMessage() {
    this.data = {
      ...this.data,
      message: null
    };
    this.trigger(this.data);
  },
  onSearch(searchText) {
    if (this.data.searchText !== searchText) {
      this.data.searchText = searchText;
      this.sync();
    }
  },
  showReportBugDialog() {
    this.data = {
      ...this.data,
      reportBug: true
    };
    this.trigger(this.data);
  },
  hideReportBugDialog() {
    this.data = {
      ...this.data,
      reportBug: false
    };
    this.trigger(this.data);
  },
  reportBug(userComment, technicalData) {
    return SteelCompass.request('guest', 'reportBug', {
      userComment,
      technicalData
    }).then(
      response => {
        this.translatableMessage('bug.reported');
      },
      () => {
        this.translatableMessage('bug.reportFailed');
      }
    );
  }
});

export default AppStore;



// WEBPACK FOOTER //
// ./src/js/stores/App.js